module.exports = __webpack_public_path__ + "img/icon_box_2_4.17f30599.png";